import { useQuery } from '@tanstack/react-query';
import { apiClient } from '../services/apiClient';

interface ExpirableGrantDetail {
  id: string;
  remaining_amount: number;
  original_amount: number;
  expires_at: string;
  grant_type: string;
  description?: string;
  days_until_expiry: number;
  granted_at: string;
}

interface ExpiringSoonInfo {
  amount: number;
  expires_at: string;
  days_until_expiry: number;
}

interface CreditsResponse {
  organization_id: string;
  organization_name: string;
  plan_type: string;
  plan_status: string;
  credits_balance: number;  // 後方互換性（= permanent_credits）
  total_purchased: number;
  total_consumed: number;
  auto_charge_enabled: boolean;
  plan_details?: {
    plan_code: string;
    display_name: string;
    monthly_fee: number;
    included_credits: number;
  };
  recent_transactions?: Array<{
    id: string;
    transaction_type: string;
    amount: number;
    balance_after: number;
    created_at: string;
  }>;
  // 期限付きポイント関連
  permanent_credits?: number;
  expirable_credits?: number;
  total_available?: number;
  expirable_credits_detail?: ExpirableGrantDetail[];
  expiring_soon?: ExpiringSoonInfo | null;
}

/**
 * 組織のポイント残高（旧クレジット）を取得するフック
 * 1ポイント = 1JPY 想定
 *
 * @param options.enabled false でフェッチを停止 (公開ホームの未ログイン閲覧など、
 *   認証無しで呼ばれ得る場面で 401 を出さないため)
 */
export function useCredits(options?: { enabled?: boolean }) {
  return useQuery<CreditsResponse>({
    queryKey: ['credits'],
    queryFn: async () => {
      const response = await apiClient.get('/organizations/me/credits');
      return response.data;
    },
    enabled: options?.enabled ?? true,
    // 5分ごとに自動更新
    refetchInterval: 5 * 60 * 1000,
    // ウィンドウフォーカス時に再取得
    refetchOnWindowFocus: true,
  });
}
